import { Navigate, Route, Routes } from 'react-router-dom';
import { BreadcrumbLine } from '../../../../../components/BreadcrumbLine/BreadcrumbLine';
import { ListMenuRoutes } from '../../../../../components/ListMenu/ListMenuRoutes';
import { DiasFestivos } from './Parametros/DiasFestivos/DiasFestivos';
import { useLang } from '../../../../../language';

const Parametros = () => {

  const Lang = useLang()

  const BreadcrumbLineItems = [
    {
      title: 'Parametros',
      link: '/parametros'
    }
  ]

  const listMenu: any = {
    dias_festivos: {
      title: Lang('DIAS_FESTIVOS'),
      link: 'dias-festivos'
    },
  }

  return (

    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className='d-flex justify-content-between align-items-center mb-1 Nav-top-DAPcon'>
            <BreadcrumbLine BreadcrumbLineItems={BreadcrumbLineItems} />
          </div>
        </div>

        <div className="col-lg-3 mb-4">

          {/* <ListMenu /> */}
          <ListMenuRoutes values={listMenu} />

        </div>

        <div className="col-lg-9 animate__animated animate__fadeInUp">

          <div className="p-2 card shadow-sm mt-4">

            {/* <TableAdvanced /> */}


            <Routes>

              <Route
                path='dias-festivos'
                element={
                  <DiasFestivos />
                }
              />

              <Route
                path="*"
                element={<Navigate to='dias-festivos' replace />}
              />
            </Routes>


          </div>
        </div>
      </div>
    </div>
  )
}

export default Parametros;